/** PURE_IMPORTS_START ._FromEventPatternObservable PURE_IMPORTS_END */
import { FromEventPatternObservable } from './FromEventPatternObservable';
export var fromEventPattern = FromEventPatternObservable.create;
//# sourceMappingURL=fromEventPattern.js.map 



//////////////////
// WEBPACK FOOTER
// ./~/rxjs/_esm5/observable/fromEventPattern.js
// module id = 771
// module chunks = 0